import React from "react";
import PropTypes from "prop-types";
import "./Button.css";

const Button = ({ onClick, type = "button", className = "", disabled = false, variant = "default", children }) => {
    return (
        <button
            type={type}
            className={`custom-button custom-button--${variant} ${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

Button.propTypes = {
    onClick: PropTypes.func,
    type: PropTypes.oneOf(["button", "submit", "reset"]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    variant: PropTypes.oneOf(["primary", "secondary", "outline", "ghost"]),
    children: PropTypes.node.isRequired,
};

export default Button;